"use client";
import React from "react";
import PropTypes from "prop-types";
import LinkContainer from "@/components/LinkContainer";
import Image from "next/image";
import {MUSIC_TYPES, previewCoverLoader} from "@/lib/common";

const coverAltText = (title, artist) => `Cover art for "${title}" by ${artist}`;

const MusicPostCard = ({
  id,
  title = "Unknown Song",
  artist = "Someone",
  date = "XXXX",
  type = "song",
  coverId = null,
}) => (
  <div className="card is-song-preview"
       data-theme="light"
       style={{width: "192px"}}
  >
    <LinkContainer href={`/music/${id}`}>
      <div className="card-image">
        <figure className="image is-192x192">
          <Image alt={coverAltText(title, artist)}
                 height={192}
                 loader={previewCoverLoader}
                 src={coverId}
                 width={192}
          />
        </figure>
      </div>
      <div className="card-content">
        <article className="media">
          <div className="media-content m-0">
            <p className="title is-6 is-clipped mb-0"
               style={{
                 textOverflow: "ellipsis",
                 whiteSpace: "nowrap",
               }}
            >
              {title}
            </p>
            <p className="subtitle mt-0 is-7 has-text-gray">
              <i>({MUSIC_TYPES[type]})</i>
            </p>
            <p className="subtitle is-7">
              <i>
                <small>by</small> {artist}
              </i>
              , {date}
            </p>
          </div>
        </article>
      </div>
    </LinkContainer>
  </div>
);

MusicPostCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired,
  artist: PropTypes.string.isRequired,
  date: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  type: PropTypes.string.isRequired,
  coverId: PropTypes.string,
};

export default MusicPostCard;
